<!--
 * @author: YiuHai
 * @Date: 2022-03-15 15:46:16
 * @description: 一些描述
 * @LastEditors: YiuHai
 * @LastEditTime: 2022-03-17 16:32:06
 * @FilePath: /app1/src/views/retureBoard/component/table.vue
-->
<template>
  <div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        align-items: center;
      "
    >
      <div style="font-size: 14px; font-weight: bold">退费明细</div>
      <el-select v-model="classType" @change="init">
        <!-- 班型：1基础班，3vip班 -->
        <el-option label="全部班型" :value="-1"></el-option>
        <el-option label="基础班" :value="1"></el-option>
        <el-option label="vip班" :value="3"></el-option>
      </el-select>
    </div>
    <el-table
      class="board-table"
      v-if="timeType === 1"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
    >
      <!-- 订单支付时间 -->
      <el-table-column align="center" label="事业部">
        <template slot-scope="scope">
          <span>{{ getCompanyName(scope.row.belongCompanyId) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="payAmt" label="已支付订单金额">
        <template slot-scope="scope">
          {{ scope.row.payAmt ? scope.row.payAmt.toFixed(2) : 0 }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="applyAmt" label="申请退费金额">
      </el-table-column>
      <el-table-column align="center" prop="alreadyAmt" label="已退费金额">
      </el-table-column>
      <el-table-column align="center" prop="amtRatio" label="已退费金额占比">
        <template slot-scope="scope">
          {{ scope.row.amtRatio ? scope.row.amtRatio + "%" : "0%" }}
        </template>
      </el-table-column>
    </el-table>
    <!-- 申请退费时间 -->
    <el-table
      class="board-table"
      v-if="timeType === 2"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
    >
      <el-table-column align="center" label="事业部">
        <template slot-scope="scope">
          <span>{{ getCompanyName(scope.row.belongCompanyId) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="applyNum"
        label="申请退费工单数"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="applyAmt"
        label="申请退款金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="alreadyNum"
        label="已退费工单数"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="alreadyAmt"
        label="已退费金额"
      ></el-table-column>
      <el-table-column align="center" prop="numRatio" label="已退费工单占比">
        <template slot-scope="scope">
          {{ scope.row.numRatio ? scope.row.numRatio + "%" : "0%" }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="amtRatio" label="已退费金额占比">
        <template slot-scope="scope">
          {{ scope.row.amtRatio ? scope.row.amtRatio + "%" : "0%" }}
        </template>
      </el-table-column>
    </el-table>
    <el-table
      class="board-table"
      v-if="timeType === 3"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
    >
      <!-- 完成退费时间 -->
      <el-table-column align="center" label="事业部">
        <template slot-scope="scope">
          <span>{{ getCompanyName(scope.row.belongCompanyId) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="alreadyNum"
        label="已退费工单数"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="alreadyAmt"
        label="已退费金额"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBoardTableDataApi } from "@/api/retureBoard";
export default {
  props: {
    companyArray: {
      type: Array,
      default: () => [],
    },
    companyId: [String, Number],
    timeType: [String, Number],
    timeRange: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      classType: -1,
      tableData: [],
    };
  },
  computed: {
    getCompanyName() {
      return function (belongCompanyId) {
        const company = this.companyArray.find((e) => e.id == belongCompanyId);
        return company ? company.appName : "--";
      };
    },
  },
  methods: {
    init() {
      const _params = {
        belongCompanyId: this.companyId == 1 ? null : this.companyId,
        dateType: this.timeType,
        classType: this.classType == -1 ? null : this.classType,
      };
      if (this.timeRange.length > 0) {
        _params.thatDateStart = this.timeRange[0] + " 00:00:00";
        _params.thatDateEnd = this.timeRange[1] + " 23:59:59";
      } else {
        _params.thatDateStart = null;
        _params.thatDateEnd = null;
      }
      getBoardTableDataApi(_params).then((result) => {
        this.tableData = result.data;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      // console.log(columns, data);
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (values.length > 0) {
          sums[index] = values.reduce(
            (prev, curr) => Number(prev || 0) + Number(curr || 0)
          );
          if (sums[index] > 0 && column.label.indexOf("单数") === -1) {
            sums[index] = sums[index].toFixed(2);
          }
        }
        // 订单支付金额
        if (this.timeType === 1 && column.label === "已退费金额占比") {
          const _value = ((sums[3] / sums[1]) * 100).toFixed(2);
          sums[index] = isNaN(_value) ? "0%" : _value + "%";
        }
      });
      if (this.timeType === 2) {
        // 申请退费时间
        const _value1 = ((sums[3] / sums[1]) * 100).toFixed(2);
        sums[5] = isNaN(_value1) ? "0%" : _value1 + "%"; // 退费工单占比 = 已退费工单数 / 申请退费工单数
        const _value2 = ((sums[4] / sums[2]) * 100).toFixed(2);
        sums[6] = isNaN(_value2) ? "0%" : _value2 + "%"; // 已退费金额占比 = 已退费金额 / 申请退费金额
      }
      return sums;
    },
  },
};
</script>

<style lang="scss">
.board-table {
  .el-table__cell {
    .cell:empty::before {
      content: "0";
    }
  }
  .el-table__footer-wrapper .has-gutter {
    tr td {
      background: #fff;
    }
  }
}
</style>
